import EventEmitter from "base/EventEmitter";

class AbstractVideo extends EventEmitter {

    constructor(data, $element, settings = {}) {
        super();

        this.data = data;

        this.video_id = data.customData.id;

        this.$element = $element;
        this.settings = $.extend(true, {}, AbstractVideo.DEFAULT_SETTINGS, settings);
        this.loaded = false;

        if (this.$element.is("[id]")) {
            this.element_id = this.$element.attr("id");
        } else {
            this.element_id = "video-" + ValueHelper.random_string();
            this.$element.attr("id", this.element_id);
        }

        this.on("loaded", () => {
            this.loaded = true;
        });
    }

    isLoaded() {
        return this.loaded;
    }

    /**
     * Makes the video play
     * @abstract
     */
    play() {
        throw new Error("Video must override play method");
    }

    /**
     * Pause the player, retaining it's current play position
     * @abstract
     */
    pause() {
        throw new Error("Video must override pause method");
    }

    /**
     * Stops the video and resets the player to it's default state (seeks to 0)
     * @abstract
     */
    stop() {
        throw new Error("Video must override stop method");
    }

    /**
     *
     * @param {number} time Integer in seconds to seek to
     * @abstract
     */
    seek(time) {
        throw new Error("Video must override seek method");
    }

    /**
     * Updates the volume
     * @param {number} volume A float between 0 and 1
     * @abstract
     */
    setVolume(volume) {
        throw new Error("Video must override setVolume method");
    }

    /**
     * @abstract
     * @param videoId
     */
    static get_video_details(videoId) {
        throw new Error("Video must override get_video_details method");
    }
}

AbstractVideo.DEFAULT_SETTINGS = {
    autoplay: false,
};

export default AbstractVideo;
